import styled from 'styled-components';
import { layout, media } from 'src/components/base';
import { ButtonText } from '@prisjakt/ui/button';

export const VariantGridWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(4, [col] 1fr);
  gap: ${layout.measurements.spacing050};

  & + & {
    margin-top: ${layout.measurements.spacing050};
    padding-top: ${layout.measurements.spacing050};
    border-top: 1px solid ${p => p.theme.lines.primary};
  }

  ${media.mediumUp`
    margin: 0 ${layout.measurements.spacing050};
    grid-template-columns: repeat(5, max-content);
  `}
`;

export const VariantGridCell = styled.div`
  min-width: 62px;
  padding: 1px;
`;

export const SelectionButtonText = styled(ButtonText)`
  max-width: 100px;
`;

export const StyledShowMoreButtonWrapper = styled.div`
  grid-column: col / span 4;
`;
